import { useCallback } from 'react';

import { insertExternalChannelItems } from 'src/components/RichSlate/utils';

export const useHandlers = ({
  setAnchorEl,
  setSearchTerm,
  setFilter,
  onResultClick,
  editor,
  onCloseMenu,
}) => {
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleUpdateSearchTerm = useCallback(
    (event) => {
      setSearchTerm(event.target.value);
    },
    [setSearchTerm]
  );

  const handleUpdateFilter = useCallback(
    (filter) => {
      handleMenuClose();
      setFilter(filter);
    },
    [setFilter, handleMenuClose]
  );

  const handleResultClick = useCallback(
    async ({ name, items }) => {
      const selectedItems = await onResultClick({ name, items });
      if (selectedItems?.length) {
        insertExternalChannelItems(editor, selectedItems);
        onCloseMenu();
      }
    },
    [onResultClick, editor, onCloseMenu]
  );

  return {
    handleMenuClick,
    handleUpdateSearchTerm,
    handleUpdateFilter,
    handleResultClick,
    handleMenuClose,
  };
};
